import { createSlice } from '@reduxjs/toolkit'

export const initialStateMandateSlice = {
    mandateType: '',
    mandateData: {},
    userLoggedIn: false,
    showLanguage: true,
    userType: 'LAP'
}
export const MandateSlice = createSlice({
    name: "mandate",
    initialState: initialStateMandateSlice,
    reducers: {
        setMandateType: (state, action) => {
            state.mandateType = action.payload;
        },
        setMandateData: (state, action) => {
            state.mandateData = action.payload;
        },
        setmandateID: (state, action) => {
            state.mandateID = action.payload;
        },
        setLoggedIn: (state, action) => {
            state.userLoggedIn = action.payload;
        }, 
        setMobileNo: (state, action) => {
            state.mobileNo = action.payload;
        },
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        setMandate: (state, action) => {
            state.mandate = action.payload;
        },
        setPartner: (state, action) => {
            state.partner = action.payload;
        },
        setFailure: (state, action) => {
            state.failure = action.payload;
        },
        setPartnerName: (state, action) => {
            state.partnerName = action.payload;
        },
        setmandateIdType: (state, action) => {
            state.mandateIdType = action.payload;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setShowLanguage: (state, action) => {
            state.showLanguage = action.payload;
        },
        setBase64Data: (state, action) => {
            state.base64Data = action.payload;
        },
        setLosId: (state, action) => {
            state.losId = action.payload;
        },
        setMobileMode: (state, action) => {
            state.mobileMode = action.payload;
        },
        setVertical : (state, action) => {
            state.vertical = action.payload;
        },
        setOtpTriggered : (state, action) => {
            state.otpTriggered = action.payload;
        },
        setUserType: (state, action) => {
            state.userType = action.payload;
        },
        
    }
})

export const {
    setMandateType,
    setMandateData,
    setmandateID,
    setLoggedIn,
    setMobileNo,
    setMessage,
    setMandate,
    setPartner,
    setFailure,
    setmandateIdType,
    setPartnerName,
    setLanguage,
    setBase64Data,
    setShowLanguage,
    setLosId,
    setVertical,
    setMobileMode,
    setOtpTriggered,
    setUserType
} = MandateSlice.actions;
export default MandateSlice.reducer;